import React, { memo } from 'react';
import GaugeChart from '@components/gaugeChart';

function ComplexityGaugeIndicator({ selectMode, ...props }) {
  return selectMode ? (
    <GaugeChart
      {...props}
      controlled={false}
      isEditing={selectMode}
      key="edit"
    />
  ) : (
    <GaugeChart {...props} key="view" />
  );
}

export default memo(ComplexityGaugeIndicator);
